import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/default_weishouquan@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-55a95bfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 1,
  class: "box_notfound"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { reactive, ref } from "vue"
    import { useStore } from "vuex"
    // import { BrowserMultiFormatReader } from '@zxing/library'
    import vTags from '@/components/common/Tags.vue'
    import vMenu from '@/components/common/Menu.vue'
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore()
    // let openCode = ref<boolean>(false)

    // let loadingShow = ref<boolean>(false)
    // let codeReader: any = ref(null)
    // let vin = ref<null>(null)
    // let scanText = ref<string>('')
    // let tipMsg = ref<string>('正在尝试识别....')
    // let tipShow = ref<boolean>(false)

    // tags组件所需数据
    const data = reactive<Array<object>>([
        {
            id: 1,
            name: '今日',
            isActive: true
        },
        {
            id: 2,
            name: '本月',
            isActive: false
        }
    ])

    // 点击标签回调
    const changeTage = (id: string | number): void => {
        console.log(id)
    }
    // const openScan = async() => {
    //     codeReader.value.getVideoInputDevices().then((videoInputDevices: any) => {
    //         tipShow.value = true;
    //         tipMsg.value = '正在调用摄像头...';
    //         console.log('videoInputDevices', videoInputDevices);
    //         // 默认获取第一个摄像头设备id
    //         let firstDeviceId = videoInputDevices[0].deviceId;
    //         // 获取第一个摄像头设备的名称
    //         const videoInputDeviceslablestr = JSON.stringify(videoInputDevices[0].label);
    //         if (videoInputDevices.length > 1) {
    //             // 判断是否后置摄像头
    //             if (videoInputDeviceslablestr.indexOf('back') > -1) {
    //                 firstDeviceId = videoInputDevices[0].deviceId;
    //             } else {
    //                 firstDeviceId = videoInputDevices[1].deviceId;
    //             }
    //         }
    //         decodeFromInputVideoFunc(firstDeviceId);
    //     }).catch((err: any) => {
    //         tipShow.value = false;
    //         console.error(err);
    //     });
    // }
    //
    // const openScanTwo = async () => {
    //     codeReader.value = await new BrowserMultiFormatReader();
    //     codeReader.value.getVideoInputDevices().then((videoInputDevices: any) => {
    //         tipShow.value = true;
    //         tipMsg.value = '正在调用摄像头...';
    //         console.log('videoInputDevices', videoInputDevices);
    //         // 默认获取第一个摄像头设备id
    //         let firstDeviceId = videoInputDevices[0].deviceId;
    //         // 获取第一个摄像头设备的名称
    //         const videoInputDeviceslablestr = JSON.stringify(videoInputDevices[0].label);
    //         if (videoInputDevices.length > 1) {
    //             // 判断是否后置摄像头
    //             if (videoInputDeviceslablestr.indexOf('back') > -1) {
    //                 firstDeviceId = videoInputDevices[0].deviceId;
    //             } else {
    //                 firstDeviceId = videoInputDevices[1].deviceId;
    //             }
    //         }
    //         decodeFromInputVideoFunc(firstDeviceId)
    //     }).catch((err: any) => {
    //         tipShow.value = false;
    //         console.error(err);
    //     });
    // }
    //
    // const decodeFromInputVideoFunc = (firstDeviceId: any) => {
    //     codeReader.value.reset(); // 重置
    //     scanText.value = '';
    //     codeReader.value.decodeFromInputVideoDeviceContinuously(firstDeviceId, 'video', (result: any, err: any) => {
    //         tipMsg.value = '正在尝试识别...';
    //         scanText.value = '';
    //         if (result) {
    //             console.log('扫描结果', result);
    //             scanText.value = result.text;
    //             if (scanText.value) {
    //                 tipShow.value = false
    //                 // 这部分接下去的代码根据需要，读者自行编写了
    //                 // this.$store.commit('app/SET_SCANTEXT', result.text);
    //                 // console.log('已扫描的小票列表', this.$store.getters.scanTextArr);
    //             }
    //         }
    //         if (err && !(err)) {
    //             tipMsg.value = '识别失败';
    //             setTimeout(() => {
    //                 tipShow.value = false;
    //             }, 2000)
    //             console.error(err)
    //         }
    //     });
    // }
    //
    // const reset = () => {
    //     codeReader.value.reset()
    // }
    //
    // onMounted(() => {
    //     console.log('浏览器信息', navigator.userAgent)
    //     codeReader.value = new BrowserMultiFormatReader()
    //     openScanTwo()
    // })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(store).state.Menu.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(store).state.Menu, (item) => {
          return (_openBlock(), _createBlock(vMenu, {
            class: "top",
            key: item.id,
            title: item.label,
            isShow: false,
            list: item.children
          }, null, 8, ["title", "list"]))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
  ]))
}
}

})